import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HelpIconComponent} from './help-icon.component';
import {ListGroupModule} from 'ng-design-system';
import {I18nModule} from '@spartacus/core';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {SafePipeModule} from '../../../pipes/safeResourceUrl/safeResourceUrl.module';
import {GenericLinkModule} from '@spartacus/storefront';
import {HelpIconLinksComponent} from './help-icon-links/help-icon-links.component';


@NgModule({
  declarations: [HelpIconComponent, HelpIconLinksComponent],
  imports: [
    CommonModule,
    ListGroupModule,
    I18nModule,
    NgbDropdownModule,
    SafePipeModule,
    GenericLinkModule
  ],
  exports: [
    HelpIconComponent
  ]
})
export class HelpIconModule {
}
